import { WalletState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const getters = {
  userWallets: (state: WalletState) => state.wallets,
  userOneWallet: (state: WalletState) => (walletId: number) => {
    const filteredWallets = state.wallets.filter(
      (wallet) => wallet.id === walletId
    );
    if (filteredWallets.length > 0) {
      return { ...filteredWallets[0] };
    }
  },
  currencyName: (state: WalletState) => (currencyId: number) => {
    return state.currencies.find((currency) => currency.id === currencyId)
      ?.name;
  },
  currencyPrice: (state: WalletState) => (currencyId: number) => {
    return (
      state.prices.find((price) => price.currency === currencyId)!
        .unit_price_internal_rls_buy / 10
    );
  },
  currencies: (state: WalletState) => state.currencies,
  walletBalance: (state: WalletState) => (walletId: number) => {
    const filteredWallets = state.wallets.filter(
      (wallet) => wallet.id === walletId
    );
    if (filteredWallets.length > 0) {
      return { ...filteredWallets[0].wallet_balance };
    }
  },
};

const { read } = getStoreAccessors<WalletState, State>("");

export const readUserOneWallet = read(getters.userOneWallet);
export const readUserWallets = read(getters.userWallets);
export const readCurrencies = read(getters.currencies);
export const readWalletBalance = read(getters.walletBalance);
export const readCurrencyName = read(getters.currencyName);
export const readCurrencyPrice = read(getters.currencyPrice);
